import type { ClearinghouseState } from '@/lib/utils/hyper/types'
import CryptoIcon from '../ui/CryptoIcon'
import { Text, HStack, VStack, Box, useBreakpointValue } from '@chakra-ui/react'
import { Back } from '../ui/svgs/back'
import { useEffect, useRef, useState } from 'react'
import { MAX_WIDTH_IN_WINDOW } from '@/lib/config/page'
import { useMaxScreenWidthInClient } from '@/lib/hooks/useMaxScreenWidthInClient'

interface PositionDetailNavProps {
  position: ClearinghouseState['assetPositions'][0]['position']
  onBack: () => void
}

export function PositionDetailNav({ position, onBack }: PositionDetailNavProps) {
  const isLongPosition = Number.parseFloat(position.szi) > 0
  const coin = position.coin.replace('-PERP', '')
  const leverage = position.leverage.value

  const { maxW } = useMaxScreenWidthInClient()

  const containerRef = useRef<HTMLDivElement>(null)
  const [paddingHeight, setPaddingHeight] = useState(0)

  useEffect(() => {
    setPaddingHeight(containerRef.current?.clientHeight || 0)
  }, [])

  return (
    <>
      <HStack 
        ref={containerRef}
        align="center" 
        gap={0.5} 
        bg="black"
        px={5}
        py={2.5}
        w="full"
        maxWidth={maxW}
        pos={"fixed"}
        top={0}
        left="50%"
        transform="translateX(-50%)"
        backdropBlur="md"
        zIndex={1000}
      >
        {/* Back Button */}
        <VStack h={5} w={5} align="center" justify="center" onClick={onBack}>
          <Back />
        </VStack>

        {/* Token Info */}
        <HStack align="center" gap={2}>
          {/* Token Icon */}
          <CryptoIcon symbol={coin} size={20} />

          {/* Token Details */}
          <HStack align="center" gap={2} >
            <Text fontSize="lg" color="text.t1" fontWeight="medium">{coin}</Text>
            <HStack align="center" gap={1}>
              <Box px={1.5} py={0.5} rounded="full" bg={isLongPosition ? 'profit/20' : 'loss/20'}>
                <Text fontSize="sm" color={isLongPosition ? 'profit' : 'loss'} fontWeight="medium">
                  {isLongPosition ? 'Long' : 'Short'}
                </Text>
              </Box>
              <Box px={1.5} py={0.5} rounded="full" bg="white/10">
                <Text fontSize="sm" color="text.t1/80" fontWeight="medium">{leverage}x</Text>
              </Box>
            </HStack>
          </HStack>
        </HStack>
      </HStack>
      <Box height={`${paddingHeight}px`}></Box>
    </>
  )
}
